import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useRoleGuard } from "@/hooks/use-role-guard";
import { SidebarLayout } from "@/components/sidebar-layout";

export const Route = createFileRoute("/investor")({
  head: () => ({
    meta: [
      { title: "Investor - DeckScore" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: InvestorLayout,
});

function InvestorLayout() {
  const { status } = useRoleGuard(["investor", "admin", "super_admin"]);

  const items = [
    { to: "/investor", label: "Overview" },
    { to: "/investor/deals", label: "Deals" },
    { to: "/investor/share", label: "Share kit" },
    { to: "/investor/profile", label: "Profile" },
  ];

  return (
    <SidebarLayout area="Investor" items={items}>
      {status === "loading" ? (
        <p className="text-ink-secondary">Loading…</p>
      ) : (
        <Outlet />
      )}
    </SidebarLayout>
  );
}
